<template>
    <div id="app">
      <navigation v-show="$store.getters.checkAuth"></navigation>
      <div class="main">
        <status></status>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
  </div>
</template>

<script>
  import Status from './components/assets/Status.vue';
  import Navigation from './components/includes/Navigation.vue';

export default {
  name: 'app',
  components:{
    Navigation,
    Status
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?2178853a